import { RefObject, useEffect, useState } from 'react';

const DEFAULT_WIDTH = 0;

export const useContainerWidth = (ref: RefObject<HTMLElement>): number => {
  const [width, setWidth] = useState(DEFAULT_WIDTH);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    const updateWidth = (): void => {
      setWidth(element.clientWidth);
    };

    updateWidth();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver((entries) => {
        const entry = entries[0];

        if (entry) {
          setWidth(Math.round(entry.contentRect.width));
        }
      });

      observer.observe(element);

      return () => {
        observer.disconnect();
      };
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateWidth);

      return () => {
        window.removeEventListener('resize', updateWidth);
      };
    }

    return undefined;
  }, [ref]);

  return width;
};
